<template>
  <div>
    <a class="text--underline shipping-tooltip font-16" href="javascript:void(0)" @click.prevent="getShipping(rowData)" :style="customStyle">
      {{ shippingFee.estimated_fee_in_number > 0 || isShowEstimatedFee ? formatAmount(shippingFee.estimated_fee_in_number) : '送料確認' }}
      <div v-if="shippingFee.estimated_fee_in_number < 0 || isShowEstimatedFee && rowData.asin === shippingFee.asin" @click.stop="" :class="`shipping-tooltiptext shipping-tooltiptext-${rowData.asin}`">
        <div class="text-left">{{ shippingFee.displayable_estimated_fee }}</div>
        <div class="text-right">{{ shippingFee.estimated_fee }}</div>
      </div>
    </a>
  </div>
</template>

<script>
import ProductService from '@/services/productservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import Util from '@/common/utility'

export default {
  props: {
    rowData: {
      type: Object,
      default () {
        return {}
      }
    },
    checkFrom: {
      type: String,
      default: 'list'
    },
    customStyle: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      shippingFee: {
        asin: '',
        displayable_estimated_fee: '',
        estimated_fee: '',
        estimated_fee_in_number: this.rowData.shippingFee
      },
      loader: null,
      isShowEstimatedFee: false
    }
  },

  methods: {
    async getShipping (product) {
      this.trackLogGetShipping(product)
      this.shippingFee = {
        asin: '',
        displayable_estimated_fee: '',
        estimated_fee: '',
        estimated_fee_in_number: this.rowData.shippingFee
      }
      this.loader = this.$loading.show()
      await ProductService.getShipping({
        sku: product.sku
      }).then(response => {
        this.shippingFee = { asin: product.asin, ...response.data.records.data }
        if (this.shippingFee.estimated_fee_in_number > 0) {
          this.rowData.shippingFee = this.shippingFee.estimated_fee_in_number
        }
        if (this.shippingFee.estimated_fee_in_number < 0 && this.rowData.shippingFee > 0) {
          this.isShowEstimatedFee = true
          this.shippingFee.estimated_fee_in_number = this.rowData.shippingFee
        }
        let tooltipClass = `.shipping-tooltiptext-${product.asin}`
        window.addEventListener('click', (e) => {
          if (document.querySelector(tooltipClass) !== null && !document.querySelector(tooltipClass).contains(e.target)) {
            if (this.isShowEstimatedFee) {
              this.shippingFee.asin = ''
            } else {
              this.shippingFee.estimated_fee_in_number = 0
            }
          }
        })
        this.loader && this.loader.hide()
      }).catch(err => {
        this.shippingFee = {}
        this.error = err
        this.loader && this.loader.hide()
      })
    },
    formatAmount (value) {
      return (value === null || typeof value === 'undefined' || value === 0) ? '¥-' : `¥${Util.formatMoney(value)}`
    },
    trackLogGetShipping (product) {
      if (this.checkFrom && ['list', 'add-by-amazon'].includes(this.checkFrom)) {
        let logParamsName = eventCode.manage_products.list_tab.check_shipping_fee
        if (this.checkFrom === 'add-by-amazon') {
          logParamsName = eventCode.manage_products.add_by_amazon_tab.check_shipping_fee
        }
        let logParams = {
          name: logParamsName,
          properties: {
            asin: product.asin
          }
        }
        EventService.postTrackLog(logParams)
      }
    }
  }
}
</script>

<style scoped>
.shipping-tooltip {
  position: relative;
  display: inline-block;
}
.shipping-tooltip:focus {
  color: #008cc6;
  text-decoration: underline;
}
.shipping-tooltip .shipping-tooltiptext {
  visibility: visible;
  width: 230px;
  background-color: #7f7f7f;
  color: #fff;
  padding: 5px 5px 0px;
  position: absolute;
  z-index: 99;
  bottom: 180%;
  left: 40%;
  margin-left: -60px;
  font-weight: bold;
  line-height: 35px;
}
.shipping-tooltip .shipping-tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 20%;
  margin-left: -5px;
  border-width: 15px;
  border-style: solid;
  border-color: #7f7f77 transparent transparent transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/ShippingFee.vue